import React, { useEffect, useRef } from 'react';
import cn from 'classnames';

import { useRightSidePanelScroll } from '@/components/common/RightSidePanel/useRightSidePanelScroll';
import styles from './rightside-panel.module.scss';
import ActionsContainer from './Actions.container';
import { TabKeys } from '../../types';

interface IRightSidePanelProps {
  isOpen: boolean;
  onCollapse: Function;
  onExcelExport: () => void;
  onIgnoreOrRestoreAction: (tabName: TabKeys) => void
}

export default function RightSidePanel({
  isOpen,
  onCollapse,
  onExcelExport,
  onIgnoreOrRestoreAction,
}: IRightSidePanelProps) {
  const panelRef = useRef<HTMLDivElement | null>(null);
  const panelBodyRef = useRef<HTMLDivElement | null>(null);
  const handleScroll = useRightSidePanelScroll(panelRef);

  const onClick = () => {
    onCollapse(!isOpen);
  };

  useEffect(() => {
    // Call handleScroll first time without scroll event
    // since need to set start position
    handleScroll();
    document.addEventListener('scroll', handleScroll);

    return () => {
      document.removeEventListener('scroll', handleScroll);
    };
  }, [handleScroll]);

  // to show the list from the beginning
  // every time when user opens Right Panel
  useEffect(() => {
    if (!isOpen && panelBodyRef.current) {
      panelBodyRef.current.scrollTo(0, 0);
    }
  }, [isOpen]);

  return (
    <div
      ref={panelRef}
      className={cn(styles['rightside-panel'], {
        [styles['rightside-panel--open']]: isOpen
      })}
    >
      <button
        type="button"
        className={styles['collapse-button']}
        onClick={onClick}
      >
        <span />
      </button>

      <div
        ref={panelBodyRef}
        className={styles.body}
      >
        {isOpen && (
          <ActionsContainer
            onExcelExport={onExcelExport}
            onIgnoreOrRestoreAction={onIgnoreOrRestoreAction} />
        )}
      </div>
    </div>
  );
}
